import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const KinoTheater = () => (
  <div className="breadcrumbs">

  <Helmet>
    <title>KinoTheater LUZIFER - Сергей Мавроди: Экранизация и Анимация</title>
    <meta
      name="description"
      content="KinoTheater LUZIFER: смотрите экранизацию 'Сын Люцифера', анимацию стихов и проект 'ZОМБИ' на официальном сайте Сергея Мавроди."
    />
    <meta name="keywords" content="Сергей Мавроди, KinoTheater, Сын Люцифера, стихи, анимация, ZОМБИ, кино" />
    <meta name="author" content="Сергей Мавроди" />
    <meta property="og:title" content="KinoTheater LUZIFER - Сергей Мавроди" />
    <meta
      property="og:description"
      content="Раздел KinoTheater LUZIFER: экранизация 'Сын Люцифера', анимация стихов и проект 'ZОМБИ'."
    />
    <meta property="og:image" content="https://sergey-mavrodi.com/images/portrait.webp" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta property="og:url" content="https://sergey-mavrodi.com/kinotheater" />
    <meta property="og:type" content="website" />
    <meta property="og:locale" content="ru_RU" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="KinoTheater LUZIFER - Сергей Мавроди" />
    <meta
      name="twitter:description"
      content="Раздел KinoTheater LUZIFER: экранизация 'Сын Люцифера', анимация стихов и проект 'ZОМБИ'."
    />
    <meta name="twitter:image" content="https://sergey-mavrodi.com/images/portrait.webp" />
    <link rel="canonical" href="https://sergey-mavrodi.com/kinotheater" />
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        'name': 'KinoTheater LUZIFER',
        'description': 'Раздел KinoTheater LUZIFER на сайте Сергея Мавроди: экранизация "Сын Люцифера", анимация стихов и проект "ZОМБИ".',
        'url': 'https://sergey-mavrodi.com/kinotheater',
        'image': 'https://sergey-mavrodi.com/images/portrait.webp',
        'publisher': {
          '@type': 'Organization',
          'name': 'Сергей Мавроди',
        },
        'breadcrumb': {
          '@type': 'BreadcrumbList',
          'itemListElement': [
            {
              '@type': 'ListItem',
              'position': 1,
              'name': 'Главная',
              'item': 'https://sergey-mavrodi.com/',
            },
            {
              '@type': 'ListItem',
              'position': 2,
              'name': 'KinoTheater LUZIFER',
              'item': 'https://sergey-mavrodi.com/kinotheater',
            },
          ],
        },
      })}
    </script>
  </Helmet>

    <div className="breadcrumb">
      <div id="breadcrumb">
      <Link to="/">Главная страница</Link> → KinoTheater LUZIFER
      </div>
    </div>
    <div className="content">
      <div className="content_white_cloud">
        <div className="cwc_top"></div>
        <div className="cwc_mid">
          <div className="content">
            <h2>KinoTheater LUZIFER</h2>
           
           
            <div style={{ backgroundColor: 'rgb(220, 220, 220)', textAlign: 'center' }}>
            <p>&nbsp;</p>
            <div style={{ backgroundColor: 'white', marginLeft: '30px', marginRight: '30px' }}>

            <p style={{ margin: '0 0 0 0' }}>&nbsp;</p>

<div style={{ backgroundColor: 'rgb(243, 243, 243)', marginLeft: '20px', marginRight: '20px' }}>

<strong><Link to="/kinotheater/sohnluzifers" className="yellow-underline" style={{ fontSize: '33px' }}>Сын Люцифера (экранизация)</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/kinotheater/gedichte" className="yellow-underline" style={{ fontSize: '33px' }}>Стихи (анимация)</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/kinotheater/zombi" className="yellow-underline" style={{ fontSize: '33px' }}>ZОМБИ (сериал)</Link></strong>

</div>

<p>&nbsp;</p>
</div>
<p>&nbsp;</p>
</div> 
          </div>
        </div>
        <div className="cwc_bot"></div>
      </div>
    </div>
  </div>
);

export default KinoTheater;
